export default __webpack_public_path__ + "static/media/plus-46.cb145e2e.png";